const KNOB = 6;
function drawKnob(ctx, x, y, color, halo) {
    ctx.fillStyle = halo;
    ctx.fillRect(x - 1, y - 1, KNOB + 2, KNOB + 2);
    ctx.fillStyle = color;
    ctx.fillRect(x, y, KNOB, KNOB);
}
export function drawRegionKnobs(regions) {
    return (args, drawContent) => {
        drawContent();
        if (regions.length === 0)
            return;
        const { ctx, rect, col, row, theme } = args;
        for (const { range, color } of regions) {
            for (const colLine of [range.x, range.x + range.width]) {
                if (colLine !== col && colLine !== col + 1)
                    continue;
                for (const rowLine of [range.y, range.y + range.height]) {
                    if (rowLine !== row && rowLine !== row + 1)
                        continue;
                    const x = colLine === col ? rect.x : rect.x + rect.width;
                    const y = rowLine === row ? rect.y : rect.y + rect.height;
                    drawKnob(ctx, x - KNOB / 2, y - KNOB / 2, color, theme.bgCell);
                }
            }
        }
    };
}
//# sourceMappingURL=regionKnobs.js.map